import gql from "graphql-tag";

const gqlQuery = gql`
  query Events(
    $offset: Int
    $limit: Int
    $customerId: ID
    $startDate: Calendar
    $endDate: Calendar
    $deploymentId: String
    $visible: Boolean
    $billable: Boolean
    $showDeleted: Boolean
  ) {
    events(
      offset: $offset
      limit: $limit
      customerId: $customerId
      startDate: $startDate
      endDate: $endDate
      deploymentId: $deploymentId
      visible: $visible
      billable: $billable
      showDeleted: $showDeleted
    ) {
      items {
        id
        title
        startDate
        endDate
        customerId
        contract {
          description
        }
      }
      total
    }
  }
`;

export default gqlQuery;

export const getEventAgendaQuery = ({ customerId, startDate, endDate, hasAdminPrivileges, showDeleted = false }) => ({
  query: gqlQuery,
  skip: !customerId && !startDate && !endDate,
  variables: {
    customerId,
    startDate,
    endDate,
    offset: null,
    limit: null,
    visible: hasAdminPrivileges ? null : true,
    showDeleted: hasAdminPrivileges ? showDeleted : false,
  },
});
